module.exports = __webpack_public_path__ + "assets/hamburger_disabled-5392f5.svg";